import { toLocaleFixed } from '@/utils'
import { mapState } from 'vuex'
import { standardResourceSizes, resourceOptimization } from '@/utils/resourceSizes'

export const scaling = {
    data() {
        return {
            NCUOptions: standardResourceSizes.map(option => ({ ...option }))
        }
    },
    methods: {
        toLocaleFixed(balance, precision = this.precision) {
            return toLocaleFixed(balance, precision)
        },
        currentNCU(ncu) {
            return this.NCUOptions.find(option => {
                return option.cpu === ncu
            })
        },
        currentNodePool(nodepoolId) {
            if (!Array.isArray(this.nodePools)) return null
            const current = this.nodePools.find(nodepool => nodepool.node_pool === nodepoolId)
            return current
        },
        currentLocalNodePool(nodepoolId) {
            if (!Array.isArray(this.localNodePools)) return null
            const current = this.localNodePools.find(nodepool => nodepool.node_pool === nodepoolId)
            return current
        },
        getNodepoolFamily(nodepool) {
            return resourceOptimization(nodepool)
        },
        getNodepoolPrimaryParameter(nodepool) {
            if (!nodepool) return '-'
            if (nodepool.ssd) return `${this.toLocaleFixed(nodepool.ssd, 0)} GB SSD`
            if (nodepool.gpu_type) return nodepool.gpu_type
            return `${nodepool.cpu} vCPU`
        },
        isSwitchCloudEnabled(oid = this.$route?.params?.oid) {
            return false
        }
    },
    computed: {
        ...mapState('appStore', ['nodePools', 'fetchingNodePools', 'localNodePools', 'fetchingLocalNodePools'])
    }
}
